import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';
import { debounce } from 'lodash';
import { changeTextProperty } from '../../../redux/actions/entities/texts';

class StrokeColor extends Component {
  constructor(...args) {
    super(...args);
    this.state = ({
      displayColorPicker: false,
      color: '#ffffff',
    });
    this.handleColorChange = debounce(this.handleColorChange, 500);
  }

  handleClick = () => {
    const { hasStroke } = this.props;
    if (hasStroke) {
      this.setState({ displayColorPicker: !this.state.displayColorPicker });
    }
  }

  handleBlur = () => {
    this.setState({ displayColorPicker: false });
  }

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = (color) => {
    const { hex } = color;
    this.setState({ color: hex });
    this.handleColorChange(hex);
  };

  handleColorChange = (hex) => {
    const { textFieldId } = this.props;
    this.props.dispatch(changeTextProperty(textFieldId, 'strokeColor', hex));
  }

  handleChangeCheck = () => {
    const {
      textFieldId,
      hasStroke,
    } = this.props;

    this.props.dispatch(changeTextProperty(textFieldId, 'stroke', !hasStroke));
  }

  render() {
    const {
      hasStroke,
      strokeColor,
    } = this.props;

    const {
      color,
      displayColorPicker,
    } = this.state;

    const selectedStrokeColor = !displayColorPicker ? strokeColor : color;
    const selectedColor = {
      backgroundColor: selectedStrokeColor,
    };

    const styles = {
      default: {
        popover: {
          position: 'absolute',
          zIndex: '2',
          right: '50px',
        },
      },
    };


    return (
      <div className="col color stroke textToolsIcon">
        <input type="checkbox" checked={hasStroke} id="strokeBox" onChange={this.handleChangeCheck} />
        <label className="side-label" htmlFor="strokeBox" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 13 14"
          enableBackground="new 0 0 13 14"
          style={{
            height: '13px',
            width: '14px',
            position: 'relative',
            top: '3px',
          }}
        >
          <path fill="#555555" d="M1,1h11v3h-1V2H7v10h2v1H4v-1h2V2H2v2H1V1z M0,0v5h3V3h2v8H3v3h7v-3H8V3h2v2h3V0H0z" />
        </svg>

        <input disabled={!hasStroke} type="text" value={selectedStrokeColor} className="fontColor" />
        <div
          style={selectedColor}
          className={`selected-color ${!hasStroke ? 'disabled' : ''}`}
          onClick={this.handleClick}
          onKeyUp={() => {}}
          role="button"
          tabIndex="0"
        />
        { displayColorPicker ?
          <div style={styles.popover} onMouseLeave={this.handleBlur}>
            <SketchPicker color={selectedStrokeColor} onChange={this.handleChange} />
          </div> : null }
      </div>
    );
  }
}

StrokeColor.defaultProps = {
  textFieldId: 0,
  hasStroke: false,
  strokeColor: '#fff',
};

StrokeColor.propTypes = {
  textFieldId: PropTypes.number,
  hasStroke: PropTypes.bool,
  strokeColor: PropTypes.string,
};

export default connect()(StrokeColor);



// WEBPACK FOOTER //
// ./src/components/text-tools/stroke-color/strokeColor.jsx